import { type QueryHookOptions, useQuery } from "@apollo/client";
import { MarketingQuotaUsageQuery } from "../graphql/queries";
import type {
  MarketingQuotaUsageQueryType,
  MarketingQuotaUsageQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useMarketingQuotaUsageQuery = (
  options?: QueryHookOptions<
    MarketingQuotaUsageQueryType,
    MarketingQuotaUsageQueryVariablesType
  >
) =>
  useQuery<MarketingQuotaUsageQueryType, MarketingQuotaUsageQueryVariablesType>(
    MarketingQuotaUsageQuery,
    options
  );
